// extracted by mini-css-extract-plugin
module.exports = {"card":"OrganizationalChart_card__21xzh","chart":"OrganizationalChart_chart__201Nz","buttonsContainer":"OrganizationalChart_buttonsContainer__3oxfW"};